module.exports = "<h2>プロジェクト</h2>\n\n<div *ngFor=\"let project of projects$ | async\">\n  <app-project-card\n      [project]=\"project\"\n      [isMainProject]=\"(user$ | async)?.mainProjectId == project.id\"\n      [userId]=\"(user$ | async)?.id\"\n      (invite)=\"invite($event, project.id)\">\n  </app-project-card>\n</div>\n\n<app-invite-project\n    [(opened)]=\"opened\"\n    [projectId]=\"selectedProjectId\"\n    [project]=\"selectedProject\">\n</app-invite-project>\n"


//////////////////
// WEBPACK FOOTER
// /Users/shwld/project/shwld/home-counter/app_src/src/app/pages/projects/projects.component.html
// module id = ../../../../../src/app/pages/projects/projects.component.html
// module chunks = main